import { useInduction } from "../../hooks/useInduction";
import { Button } from '../Button';

import { Container, Navigation, Quiz, QuizBox } from "./styles";
import { quizHiddenAZ } from "../../util/aliasHidden"

interface QuizzesDynamicProps {
    onOpenNewQuizDynamicModal: (quizId: number) => void;
}

export function QuizzesDynamic({ onOpenNewQuizDynamicModal }: QuizzesDynamicProps) {
    const { configuration
        , beneficiaryRegister
        , setBeneficiary
        , setValueDisplayQuizzes
        , setValueDisplayForm
        , addedQuiz
        , quizzes
        , isActiveLoader
        , benefitName } = useInduction();

    function goBackForm() {
        setValueDisplayForm(true);
        setValueDisplayQuizzes(false);
    }

    async function handleSaveInduction() {
        await setBeneficiary([]);
    }

    function checkHasAdhession(id: number) {
        return beneficiaryRegister.quiz?.filter(f => f.id === id)[0] ? true
            : quizzes.filter(f => f.id === id)[0] ? true
                : beneficiaryRegister.quiz.map(b => b?.skuId).flat().includes(configuration.quiz.filter(cf => cf.id === id).map(c => c.drugs).flat().map(d => d?.skuId)[0]);
    }

    const isSaveDisabled = !addedQuiz || isActiveLoader;

    return (
        <>
            <Container>
                <h3>Adesão ao medicamento - <span>{benefitName}</span></h3>
                <Quiz>
                    {
                        configuration.quiz?.map(quiz => (
                            !quizHiddenAZ.includes(quiz.name.toLowerCase().replaceAll(" ", "")) &&
                            <QuizBox
                                type="button"
                                key={quiz.id}
                                hasAdhession={checkHasAdhession(quiz.id)}
                                disabled={checkHasAdhession(quiz.id)}
                                onClick={() => onOpenNewQuizDynamicModal(quiz.id)}
                            >
                                <span>{quiz.name}</span>
                            </QuizBox>
                        ))
                    }
                </Quiz>

                <Navigation>
                    <Button type="button" className="secondary-button" isActive={false} disabled={isActiveLoader} onClick={goBackForm}>
                        Voltar
                    </Button>
                    <Button type="button" isActive={isActiveLoader} disabled={isSaveDisabled} onClick={handleSaveInduction}>
                        Finalizar
                    </Button>
                </Navigation>
            </Container>
        </>
    );

}
